import { core, type Json } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 1、定位 location
 * 2、设备信息权限，如IMEI等 imei
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum SupportedRuntimeObject {
  imei = 'imei',
  location = 'location',
}

export type FabricGetSystemRuntimeInfoOptions = {
  /**
   * 当前需要实时获取的Native对象(location,...)
   */
  objects: Array<keyof typeof SupportedRuntimeObject>;
};

export type FabricGetSystemRuntimeInfoCallbackData = {
  [key in keyof typeof SupportedRuntimeObject]: Json;
};

export type FabricGetSystemRuntimeInfoApi = (
  options: FabricGetSystemRuntimeInfoOptions
) => Promise<FabricGetSystemRuntimeInfoCallbackData>;

/**
 * 异步获取当前设备需要动态获取权限的API
 * @returns Promise<FabricGetSystemRuntimeInfoCallbackData>
 */
export const getSystemRuntimeInfo: FabricGetSystemRuntimeInfoApi = (
  options: FabricGetSystemRuntimeInfoOptions
) => {
  return new Promise<FabricGetSystemRuntimeInfoCallbackData>(
    (resolve, reject) => {
      core.call<
        'fabric_utils.getSystemRuntimeInfo',
        FabricGetSystemRuntimeInfoOptions,
        FabricGetSystemRuntimeInfoCallbackData
      >('fabric_utils.getSystemRuntimeInfo', options, (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      });
    }
  );
};
